import { Navigate, Outlet } from 'react-router-dom';
import { PATHS } from '@/const';
import { useMyRole } from '@/hooks/useMyRole';

const TechnicalSupportRestricted = () => {
    const { isTechnicalSupport, isLoading } = useMyRole();
    if (isLoading) {
        return;
    }
    if (isTechnicalSupport) {
        return <Navigate replace to={PATHS.projects} />;
    }
    return <Outlet />;
};

export default TechnicalSupportRestricted;
